<div class="h-100 overflow-scroll ">
    <div class="breadcrumb_outer">
        <ul class="breadcrumb">
            <li>
                <a>{{ company_name }}:</a>
            </li>
            <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
                <a (click)="goToPageLink(item.page_ref)">
                    {{ item.page_title }}
                </a>
            </li>
        </ul>
        <div class="right">
            <span>{{ today }}</span>
            <!--here responsiveness has been used commented by Prerna Singh on 21 february 2024-->
        </div>
    </div>
    <div class="tag_powered_by bottomPowerBy">
        <span>Powered by: <b>Enertics</b></span>
    </div>

    <div class="mt-2 mb-2 d-flex align-items-center justify-content-end">
        <span class="">
            <img style="width: 20px; height: 20px; cursor: pointer" src="./assets/settings.png"
                [matMenuTriggerFor]="menu" /></span>
    </div>
    <mat-menu #menu="matMenu" class="stroked-menu" style="min-height: auto !important">
        <div class="menu-item-container">
            <button (click)="changeModalType('list_gateways')" mat-stroked-button color="accent"
                class="details-button stroked-menu-button mb-2">
                <mat-icon>info</mat-icon>
                <span>Edit Gateways</span>
            </button>
            <button (click)="changeModalType('list_sensors')" mat-stroked-button color="accent"
                class="details-button stroked-menu-button">
                <mat-icon>info</mat-icon>
                <span>Edit Sensors</span>
            </button>
        </div>
    </mat-menu>

    <div class="">
        <!-- ROW 1 -->
        <div class="d-flex gap-2">
            <app-piezo-image-container class="w-100" />
        </div>
        <!-- ROW 2 -->
        <div class="d-flex gap-2 mt-2">
            <app-piezo-table class="flex_7" />
            <div class="flex_3 d-flex flex-column gap-2 ml-2">
                <app-piezo-healthbar class="mb-2" />
                <app-piezo-alerts class="flex_3" />
            </div>
        </div>
    </div>

    <app-piezo-dashboard-modal *ngIf="modal_type=='list_gateways'" [modal_type]="modal_type"
        (close_modal)="closeModal()" />
    <app-piezo-dashboard-modal *ngIf="modal_type=='list_sensors'" [modal_type]="modal_type"
        (close_modal)="closeModal()" />
</div>